import { ready } from '~/core';
import { addEvents } from '~/utils';
import { createElement } from '~/utils';
import { media } from '~/utils';
import { retach } from '~/utils';

ready('header-nav', '.header', header => {
	const drawer = header.querySelector('.header-drawer');
	const inner = drawer.querySelector('.header-drawerInner');
	const nav = header.querySelector('.header-nav');
	const mobileTriggers = [...header.querySelectorAll('.header-trigger')];
	const triggers = [...nav.querySelectorAll('.header-navTrigger')];
	const mainLists = [
		...nav.querySelectorAll(':scope > .header-navList > .header-navItem > .header-navList'),
	];

	const setHeight = media => {
		setTimeout(() => {
			mainLists.forEach(main => {
				main.style.height = '';
				if (media.matches) {
					const cs = getComputedStyle(main);
					const padding = parseInt(cs.paddingTop) + parseInt(cs.paddingBottom);
					// Inner width the wrapped columns must fit into (panel content box).
					const availWidth =
						main.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);

					// The panel arranges its section blocks with `flex-flow: column wrap`, so the
					// height we set here decides where blocks wrap into the next column. Measure each
					// block's natural (nowrap) height and outer width — horizontal margins count
					// toward a flex column's cross-size. (Height is currently auto, so every block is
					// in one column at its natural width.) Skip the absolutely-positioned overview btn.
					const blocks = [...main.querySelectorAll(':scope > li')]
						.filter(li => !li.querySelector('.header-navLabel--btn') && li.offsetHeight > 0)
						.map(li => {
							const r = li.getBoundingClientRect();
							const ms = getComputedStyle(li);
							return { h: r.height, w: r.width + parseFloat(ms.marginLeft) + parseFloat(ms.marginRight) };
						});

					if (blocks.length) {
						const totalHeight = blocks.reduce((sum, b) => sum + b.h, 0);
						const tallestBlock = Math.max(...blocks.map(b => b.h));

						// Simulate the column-wrap packing for a candidate column-content height H:
						// fill a column top-to-bottom until the next block would exceed H, then start a
						// new column. Return the summed width of the columns (each as wide as its widest
						// block) so we can tell whether that packing fits within the panel width.
						const totalWidthFor = H => {
							let colHeight = 0, colWidth = 0, sumWidth = 0;
							blocks.forEach(b => {
								if (colHeight > 0 && colHeight + b.h > H + 0.5) {
									sumWidth += colWidth; // close current column, open a new one
									colHeight = b.h;
									colWidth = b.w;
								} else {
									colHeight += b.h;
									colWidth = Math.max(colWidth, b.w);
								}
							});
							return sumWidth + colWidth;
						};

						// A taller panel packs into fewer columns => smaller total width, so "fits the
						// panel width" is monotonic in H. Binary-search the SHORTEST height whose columns
						// still fit horizontally: that gives the most columns that fit (e.g. the 3-column
						// FR layout, since a 4th column overflows) — content- and locale-agnostic, and a
						// principled replacement for the old hard-coded `if (max === 250) max = 362` hack.
						let max = Math.ceil(totalHeight);
						if (availWidth > 0) {
							let lo = Math.ceil(tallestBlock);
							let hi = Math.ceil(totalHeight);
							max = hi;
							for (let i = 0; i < 24 && lo <= hi; i++) {
								const mid = Math.floor((lo + hi) / 2);
								if (totalWidthFor(mid) <= availWidth) {
									max = mid;
									hi = mid - 1;
								} else {
									lo = mid + 1;
								}
							}
						}
						// A few px of headroom so the tallest column always clears the wrap threshold.
						max = Math.ceil(max) + 4;

						setTimeout(() => {
							main.style.height = `${padding + max}px`;
						});
					}
				}
			});
		}, 150);
	};
	const prepare = trigger => {
		const item = trigger.closest('.header-navItem');
		const list = item.querySelector('.header-navList');
		const label = item.querySelector('.header-navLabel');
		if (list) {
			const back = createElement('li', { class: 'header-navBack' }, label.textContent);
			list.insertAdjacentElement('afterbegin', back);
			addEvents(back, 'click.self', close);
			addEvents(back, 'keyup', (e) => {
				let code = e.which;
				if(code === 32 || code === 13) {
					close()
				}
			})
			addEvents(trigger, 'click.self', function(e) {
				if (!media.lg.matches) {
					e.preventDefault();
				}
				toggle.apply(this);
			});
			addEvents(trigger, "keyup", (e) => {
				let code = e.which;
				if(code === 32 || code === 13) {
					if (!media.lg.matches) {
						e.preventDefault();
					}
					toggle.apply(this);

				}
			})
		}
	};
	const toggle = function(e) {
		const item = this.closest('.header-navItem');
		const parent = item.closest('.header-navList');
		const list = item.querySelector('.header-navList');
		const sibs = [...item.parentElement.querySelectorAll('.header-navItem')].filter(
			s => s !== item
		);

		sibs.forEach(s => s.classList.remove('is-active'));
		item.classList.toggle('is-active');
		inner.classList.add('is-locked');
		list.scrollTop = 0;
		inner.scrollTop = 0;
	};
	const close = function() {
		const item = this.closest('.header-navItem');
		const parent = item.closest('.header-navList');
		const list = item.querySelector('.header-navList');
		item.classList.remove('is-active');
		list.scrollTop = 0;
		inner.scrollTop = 0;

		if (parent.parentElement === nav) {
			inner.classList.remove('is-locked');
		} else if (media.lg.matches) {
			let start, end;
			start = `${parent.offsetHeight}px`;
			parent.style.height = '';
			end = `${parent.offsetHeight}px`;
			parent.animate([{ height: start }, { height: end }], {
				duration: 350,
				easing: 'ease',
			});
		}
	};

	setHeight(media.lg);
	media.lg.addListener(setHeight);
	triggers.forEach(trigger => prepare(trigger));
	addEvents(mobileTriggers, 'click', () => header.classList.toggle('is-open'));
	addEvents(drawer, 'click.self', () => header.classList.remove('is-open'));
	addEvents(document, 'click', e => {
		let isNav = e.target.closest('.header-nav');
		if (!isNav) {
			let items = nav.querySelectorAll('.is-active');
			items.forEach(item => (item ? close.apply(item) : false));
		}
	});
});

ready('header-retach', '.header', header => {
	const drawer = header.querySelector('.header-drawerInner');
	const nav = header.querySelector('.header-nav');
	const navList = nav.querySelector(':scope > .header-navList');
	const utilList = [...header.querySelectorAll('.header-utilList')];
  const utilListLeft = [...header.querySelectorAll('.header-utilList--left')];
	const search = header.querySelector('.header-search');

	// The utility <ul>s get appended straight into the nav <ul>, which is invalid HTML
	// (a list may only contain <li>). Wrap each moved list in its own <li> (and drop the
	// leftover <li> when it goes back) so the drawer markup stays a valid, accessible list.
	const utilRetach = {
		destination: navList,
		callback_move() {
			if (this.parentElement.classList.contains('header-navUtil')) return;
			const li = createElement('li', { class: 'header-navUtil' });
			if (this.classList.contains('header-utilList--left')) li.classList.add('header-navUtil--left');
			this.parentNode.insertBefore(li, this);
			li.appendChild(this);
		},
		callback_back() {
			navList.querySelectorAll(':scope > .header-navUtil:empty').forEach(li => li.remove());
		},
	};

	retach(nav, {
		destination: drawer,
		mediaQuery: 1198,
	});
  retach(utilListLeft, {
		...utilRetach,
		mediaQuery: 991,
	});
	retach(utilList, {
		...utilRetach,
		mediaQuery: 1198,
	});
	retach(search, {
		destination: drawer,
		mediaQuery: 1198,
	});
});
